interface ApiErrorShape {
  response?: { data?: { message?: unknown } }
}

/**
 * Mensaje legible de un fallo de API. Axios envuelve la respuesta del servidor
 * en `response.data`, donde el backend pone su `message`; si no lo hay, cae al
 * mensaje del Error.
 */
export function resolveError(err: unknown): string {
  const apiMessage = (err as ApiErrorShape)?.response?.data?.message
  if (typeof apiMessage === 'string' && apiMessage) return apiMessage
  if (err instanceof Error && err.message) return err.message
  return 'Error inesperado'
}
